import React, {useMemo} from "react";
import {useQueries} from "@tanstack/react-query";
import * as api from "../../../../api";
import HSComparisonGraph from "../../../../components/Graph/HSComparisonGraph";
import LoadingOverlay from "../../../../components/LoadingOverlay";


const StationsComparisonPanel = ({selectedFeatures}) => {
    const stations = useMemo(() => selectedFeatures.map(f => ({
        id: f.properties.id,
        code: f.properties.code,
        name: f.properties.name
    })), [selectedFeatures]);

    const results = useQueries({
        queries: stations.map(station => ({
            queryKey: ['timeseries', 'stations', station.id, {}],
            queryFn: () => api.Timeseries.getTimeseries(station.id, {}),
            enabled: !!station.id,
        }))
    });

    const isLoading = results.some(result => result.isLoading);
    const stationsData = useMemo(() => {
        const data = {};
        results.forEach((result, index) => {
            if (result.data) {
                const stationId = stations[index].id;
                data[stationId] = result.data.timestamps.map((timestamp, i) => ({
                    timestamp: timestamp,
                    hs: result.data.hs?.[i]
                }));
            }
        });
        return data;
    }, [results, stations]);

    if (isLoading) {
        return <LoadingOverlay />;
    }

    return <HSComparisonGraph stationsData={stationsData} stations={stations} />
};

export default StationsComparisonPanel;
